import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 _flexcol _gap-6 js-main-content" }
const _hoisted_2 = { class: "_grid _grid-cols-1 _grid-cols-2--m _gap-6" }
const _hoisted_3 = { class: "gfu-box gfu-box--flat gfu-box--huge gfu-bt gfu-bt--b1 _tac" }
const _hoisted_4 = { class: "_mt-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_external_link = _resolveComponent("external-link")
  const _component_base_hero = _resolveComponent("base-hero")
  const _component_base_title = _resolveComponent("base-title")
  const _component_marketing_services_values = _resolveComponent("marketing-services-values")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_footer_navigation, {
      "current-page": _ctx.Resources.Layout.MarketingServicesLink
    }, null, 8 /* PROPS */, ["current-page"]),
    _createVNode(_component_base_hero, {
      title: `${$options.platformName} marketing services`,
      type: "marketing"
    }, {
      description: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gfu-become-creator-hero__content _mb-6" }, " Boost your project's reach with our expert team. We'll manage your promotion across Facebook, Instagram, Messenger and more... From preview to pledge manager. ", -1 /* CACHED */)),
        _createVNode(_component_external_link, {
          href: $options.formUrl,
          class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide _tac"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Contact our experts ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"]),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_title, { level: "h2" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Marketing services", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "gfu-bt gfu-bt--b1" }, "Why partner with us", -1 /* CACHED */))
      ]),
      _createVNode(_component_marketing_services_values, { "marketing-services-values": $options.marketingServicesValues }, null, 8 /* PROPS */, ["marketing-services-values"]),
      _createElementVNode("div", null, [
        _createVNode(_component_base_title, { level: "h2" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("They trusted us", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.trustedUs, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title,
            class: "_pa-6 _aspect-square _rounded--common _ov-h",
            style: _normalizeStyle(item.styles)
          }, [
            _createVNode(_component_base_title, {
              level: "h1",
              class: "_tc--inherit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            _createElementVNode("div", null, _toDisplayString(item.description), 1 /* TEXT */)
          ], 4 /* STYLE */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createVNode(_component_base_title, { level: "h2" }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Reach out", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_icon, {
          name: "envelope",
          size: "4x",
          class: "_tc--accent _mb-6"
        }),
        _cache[7] || (_cache[7] = _createElementVNode("div", null, "Request support to grow your audience.", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_external_link, {
            href: $options.formUrl,
            class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide _tac"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Complete the form ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"])
        ])
      ])
    ])
  ]))
}